<template>
  <div class="body-container activity-details-container">
    <div id="main">
      <div class="container">
        <div class="activity_heading">
          <div class="row">
            <div class="col-3 col-md-2 pl-0 pr-0 arrow-padding">
              <div class="agreement" @click="goToPreviousQuestion()" v-if="showPrevButton">
                <svg xmlns="http://www.w3.org/2000/svg" width="15" height="25" fill="none" viewBox="0 0 15 25">
                  <path fill="var(--primary)" fill-rule="evenodd" d="M14.773 2.344L12.43 0 0 12.43l12.43 12.43 2.343-2.345L4.688 12.43 14.773 2.344z" clip-rule="evenodd" />
                </svg>
              </div>
            </div>
            <div class="col-6 col-md-8 text-center pb-10 p-0">
              <h2
                v-translate:dynamic_string="{
                  key: `${translationKey}`,
                  val: lang,
                  html: activity.name
                }"
                v-html="activity.name"
              ></h2>
            </div>
            <div data-toggle="modal" data-target="#activity_cancel_Modal" class="col-3 col-md-2 text-right pl-0 pr-0 pt-7 activity-modal-btn">
              <h5 v-translate:CANCEL_BUTTON_TITLE="lang">CANCEL</h5>
            </div>
          </div>
        </div>
        <!-- activity modal start -->
        <div class="activityCancelModel">
          <div ref="activityCancelModel" class="modal fade" id="activity_cancel_Modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-lg m-10" role="document">
              <div class="modal-content">
                <div class="modal-body modal-padding p-28">
                  <div class="verification text-center">
                    <h2 class="p-0 m-0" v-translate:ml_are_you_sure="lang">
                      Are you sure?
                    </h2>
                  </div>
                  <div class="d-flex justify-content-end pt-50 ml-30 mr-30">
                    <div class="col-6 col-md-6 pl-0">
                      <button data-dismiss="modal" class="btn leavestudy" v-translate:CANCEL_BUTTON_TITLE="lang">
                        Cancel
                      </button>
                    </div>
                    <div class="col-6 col-md-6 pr-0 discard-btn">
                      <button class="btn leave_study_cntue" data-dismiss="modal" @click="activityCancel" v-translate:rsb_discard_results="lang">
                        Discard Results
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <!-- activity modal end -->
        <div class="card">
          <div class="card-body" v-if="isLegacyStudy || (isLegacyStudy == false && isOldActivity)">
            <div class="select-scroll">
              <BooleanPreview
                v-if="legacyActiveQuestions && legacyActiveQuestions.constraints && legacyActiveQuestions.constraints !== null && legacyActiveQuestions.constraints.type === 'Boolean'"
                :lang="lang"
                :isLegacyStudy="isLegacyStudy || (isLegacyStudy == false && isOldActivity)"
                :question="legacyActiveQuestions"
                @onAnswerChange="onAnswerChange"
                :isFieldDisabled="disabledFields[legacyActiveQuestions.identifier]"
                :key="legacyActiveQuestions.identifier"
                :mode="modes[mode]"
              />
              <CustomScalePreview
                v-if="legacyActiveQuestions && legacyActiveQuestions.constraints && legacyActiveQuestions.constraints !== null && legacyActiveQuestions.constraints.type === 'CustomScale'"
                :lang="lang"
                :isLegacyStudy="isLegacyStudy || (isLegacyStudy == false && isOldActivity)"
                :question="legacyActiveQuestions"
                @onAnswerChange="onAnswerChange"
                :isFieldDisabled="disabledFields[legacyActiveQuestions.identifier]"
                :key="legacyActiveQuestions.identifier"
                :mode="modes[mode]"
              />
              <DateTimePreview
                v-if="legacyActiveQuestions && legacyActiveQuestions.constraints && legacyActiveQuestions.constraints !== null && (legacyActiveQuestions.constraints.type === 'DateTime' || legacyActiveQuestions.constraints.type === 'Date' || legacyActiveQuestions.constraints.type === 'Time')"
                :lang="lang"
                :isLegacyStudy="isLegacyStudy || (isLegacyStudy == false && isOldActivity)"
                :question="legacyActiveQuestions"
                @onAnswerChange="onAnswerChange"
                :isFieldDisabled="disabledFields[legacyActiveQuestions.identifier]"
                :key="legacyActiveQuestions.identifier"
                :mode="modes[mode]"
              />
              <ImageCapturePreview
                v-if="legacyActiveQuestions && legacyActiveQuestions.constraints && legacyActiveQuestions.constraints !== null && legacyActiveQuestions.constraints.type === 'ImageCapture'"
                :lang="lang"
                :isLegacyStudy="isLegacyStudy || (isLegacyStudy == false && isOldActivity)"
                :question="legacyActiveQuestions"
                @onAnswerChange="onAnswerChange"
                :isFieldDisabled="disabledFields[legacyActiveQuestions.identifier]"
                :key="legacyActiveQuestions.identifier"
                :mode="modes[mode]"
              />
              <ImageChoicePreview
                v-if="legacyActiveQuestions && legacyActiveQuestions.constraints && legacyActiveQuestions.constraints !== null && legacyActiveQuestions.constraints.type === 'Image'"
                :lang="lang"
                :isLegacyStudy="isLegacyStudy || (isLegacyStudy == false && isOldActivity)"
                :question="legacyActiveQuestions"
                @onAnswerChange="onAnswerChange"
                :isFieldDisabled="disabledFields[legacyActiveQuestions.identifier]"
                :key="legacyActiveQuestions.identifier"
                :mode="modes[mode]"
              />
              <InstructionPreview
                v-if="legacyActiveQuestions && legacyActiveQuestions.constraints && legacyActiveQuestions.constraints !== null && legacyActiveQuestions.constraints.type === 'SurveyInstruction'"
                :lang="lang"
                :isLegacyStudy="isLegacyStudy || (isLegacyStudy == false && isOldActivity)"
                :question="legacyActiveQuestions"
                @onAnswerChange="onAnswerChange"
                :isFieldDisabled="disabledFields[legacyActiveQuestions.identifier]"
                :key="legacyActiveQuestions.identifier"
                :mode="modes[mode]"
              />
              <CompletionPreview
                v-if="legacyActiveQuestions && legacyActiveQuestions.type === 'SurveyCompletion'"
                :lang="lang"
                :isLegacyStudy="isLegacyStudy || (isLegacyStudy == false && isOldActivity)"
                :question="legacyActiveQuestions"
                @onAnswerChange="onAnswerChange"
                :isFieldDisabled="disabledFields[legacyActiveQuestions.identifier]"
                :mode="modes[mode]"
                :key="legacyActiveQuestions.identifier"
              />
              <MultipleChoicePreview
                v-if="legacyActiveQuestions && legacyActiveQuestions.constraints && legacyActiveQuestions.constraints !== null && legacyActiveQuestions.constraints.type === 'MultiChoice'"
                :lang="lang"
                :isLegacyStudy="isLegacyStudy || (isLegacyStudy == false && isOldActivity)"
                :question="legacyActiveQuestions"
                @onAnswerChange="onAnswerChange"
                :isFieldDisabled="disabledFields[legacyActiveQuestions.identifier]"
                :key="legacyActiveQuestions.identifier"
                :mode="modes[mode]"
              />
              <NumberResponsePreview
                v-if="legacyActiveQuestions && legacyActiveQuestions.constraints && legacyActiveQuestions.constraints !== null && (legacyActiveQuestions.constraints.type === 'Number' || legacyActiveQuestions.constraints.type === 'Integer' || legacyActiveQuestions.constraints.type === 'Decimal')"
                :lang="lang"
                :isLegacyStudy="isLegacyStudy || (isLegacyStudy == false && isOldActivity)"
                :question="legacyActiveQuestions"
                @onAnswerChange="onAnswerChange"
                :isFieldDisabled="disabledFields[legacyActiveQuestions.identifier]"
                :key="legacyActiveQuestions.identifier"
                :mode="modes[mode]"
              />
              <NumberScalePreview
                v-if="legacyActiveQuestions && legacyActiveQuestions.constraints && legacyActiveQuestions.constraints !== null && legacyActiveQuestions.constraints.type === 'NumberScale'"
                :lang="lang"
                :isLegacyStudy="isLegacyStudy || (isLegacyStudy == false && isOldActivity)"
                :question="legacyActiveQuestions"
                @onAnswerChange="onAnswerChange"
                :isFieldDisabled="disabledFields[legacyActiveQuestions.identifier]"
                :key="legacyActiveQuestions.identifier"
                :mode="modes[mode]"
              />
              <TextResponsePreview
                v-if="legacyActiveQuestions && legacyActiveQuestions.constraints && legacyActiveQuestions.constraints !== null && legacyActiveQuestions.constraints.type === 'Text'"
                :lang="lang"
                :isLegacyStudy="isLegacyStudy || (isLegacyStudy == false && isOldActivity)"
                :question="legacyActiveQuestions"
                @onAnswerChange="onAnswerChange"
                :isFieldDisabled="disabledFields[legacyActiveQuestions.identifier]"
                :key="legacyActiveQuestions.identifier"
                :mode="modes[mode]"
              />
              <VasPreview
                v-if="legacyActiveQuestions && legacyActiveQuestions.constraints && legacyActiveQuestions.constraints !== null && legacyActiveQuestions.constraints.type === 'VAS'"
                :lang="lang"
                :question="legacyActiveQuestions"
                @onAnswerChange="onAnswerChange"
                :isFieldDisabled="disabledFields[legacyActiveQuestions.identifier]"
                :mode="modes[mode]"
                :key="legacyActiveQuestions.identifier"
                @onClick="onShowMessage"
              />
            </div>
            <button v-if="isActivityLastQuestion == false" type="button" class="signIn-btn btn primary-bg" v-on:click.prevent="submitEvent(legacyActiveQuestions, legacyActiveQuestions.constraints.type)">
              {{ currentQuestionButtonLabel }}
            </button>
            <button v-else type="button" @click="navigateToList(legacyActiveQuestions)" class="signIn-btn btn primary-bg">
              {{ currentQuestionButtonLabel }}
            </button>
            <a class="link-skip_question cursor_pointer" v-if="questions[currentQuestionIndex] && questions[currentQuestionIndex].optional" @click.stop="submitEvent(legacyActiveQuestions, legacyActiveQuestions.constraints.type, true)" v-translate:skip_this_question="lang">Skip this question</a>
          </div>
          <div class="card-body" v-else-if="isLegacyStudy == false">
            <div v-for="question in nonLegacyActiveQuestion" :key="question.identifier">
              <div class="select-scroll">
                <BooleanPreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'Boolean'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <CustomScalePreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'CustomScale'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <DateTimePreview
                  v-if="question && question.constraints && question.constraints !== null && (question.constraints.type === 'DateTime' || question.constraints.type === 'Date' || question.constraints.type === 'Time')"
                  :lang="lang"
                  :question="question"
                  :isLegacyStudy="isLegacyStudy"
                  @onAnswerChange="onAnswerChange"
                  :isFieldDisabled="disabledFields[question.identifier]"
                  :mode="modes[mode]"
                  :key="question.identifier"
                  @onClick="onShowMessage"
                />
                <ImageCapturePreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'ImageCapture'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <ImageChoicePreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'Image'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <InstructionPreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'SurveyInstruction'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <CompletionPreview v-if="question && question.type === 'SurveyCompletion'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <MultipleChoicePreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'MultiChoice'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <NumberResponsePreview
                  v-if="question && question.constraints && question.constraints !== null && (question.constraints.type === 'Number' || question.constraints.type === 'Integer' || question.constraints.type === 'Decimal')"
                  :lang="lang"
                  :question="question"
                  :isLegacyStudy="isLegacyStudy"
                  @onAnswerChange="onAnswerChange"
                  :isFieldDisabled="disabledFields[question.identifier]"
                  :mode="modes[mode]"
                  :key="question.identifier"
                  @onClick="onShowMessage"
                />
                <NumberScalePreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'NumberScale'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <TextResponsePreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'Text'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <DropDownPreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'DropDown'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <MeasurementPreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'Measurements'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <IndexPreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'Index'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <LogPreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'Log'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <WongBakerPreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'WongBaker'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <ValidatedEntryPreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'ValidatedEntry'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <MedicationSelectorPreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'MedicationSelector'" :lang="lang" :question="question" :isLegacyStudy="isLegacyStudy" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <VasPreview v-if="question && question.constraints && question.constraints !== null && question.constraints.type === 'VAS'" :lang="lang" :question="question" @onAnswerChange="onAnswerChange" :isFieldDisabled="disabledFields[question.identifier]" :mode="modes[mode]" :key="question.identifier" @onClick="onShowMessage" />
                <HelpMessage v-if="question && question.addHelpEnabled" :helpContent="question.helpContent" :isLegacyStudy="isLegacyStudy" :lang="lang" />
                <Modal :show="showMessageModal" :helpText="messageContent.messageBody" :key="'modal_' + question.identifier"></Modal>
              </div>
              <div>
                <div class="custom-footer-margin text-center" v-if="activity && activity.customFooter && isActivityLastQuestion == false">
                  <span
                    v-translate:dynamic_string="{
                      key: `${activity.activityId}_customFooterText`,
                      val: lang,
                      html: activity['customFooterText']
                    }"
                    v-html="activity['customFooterText']"
                  >
                  </span>
                </div>
                <button v-if="isActivityLastQuestion == false" type="button" class="signIn-btn btn mt-0" v-on:click.prevent="submitEvent(question, question.constraints.type)">
                  {{ currentQuestionButtonLabel }}
                </button>
                <button v-else type="button" @click="navigateToList(question)" class="signIn-btn btn primary-bg">
                  {{ currentQuestionButtonLabel }}
                </button>
                <a class="link-skip_question cursor_pointer" v-if="question.optional == true" @click.stop="submitEvent(question, question.constraints.type, true)" v-translate:skip_this_question="lang">Skip this question</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BooleanPreview from "@/components/participant-portal/activity/activity-steps/boolean.vue";
import CustomScalePreview from "@/components/participant-portal/activity/activity-steps/custom-scale.vue";
import DateTimePreview from "@/components/participant-portal/activity/activity-steps/date-time.vue";
import ImageCapturePreview from "@/components/participant-portal/activity/activity-steps/image-capture.vue";
import ImageChoicePreview from "@/components/participant-portal/activity/activity-steps/image-choice.vue";
import InstructionPreview from "@/components/participant-portal/activity/activity-steps/instruction.vue";
import CompletionPreview from "@/components/participant-portal/activity/activity-steps/completion.vue";
import MultipleChoicePreview from "@/components/participant-portal/activity/activity-steps/multiple-choice.vue";
import NumberResponsePreview from "@/components/participant-portal/activity/activity-steps/number-response.vue";
import NumberScalePreview from "@/components/participant-portal/activity/activity-steps/number-scale.vue";
import TextResponsePreview from "@/components/participant-portal/activity/activity-steps/text-response.vue";
import DropDownPreview from "@/components/participant-portal/activity/activity-steps/drop-down.vue";
import MeasurementPreview from "@/components/participant-portal/activity/activity-steps/measurement.vue";
import IndexPreview from "@/components/participant-portal/activity/activity-steps/index.vue";
import LogPreview from "@/components/participant-portal/activity/activity-steps/log.vue";
import WongBakerPreview from "@/components/participant-portal/activity/activity-steps/wong-baker-faces.vue";
import ValidatedEntryPreview from "@/components/participant-portal/activity/activity-steps/validated-entry.vue";
import MedicationSelectorPreview from "@/components/participant-portal/activity/activity-steps/med-selector.vue";
import VasPreview from "@/components/participant-portal/activity/activity-steps/vas.vue";

import { Bitrise, Activity, Validations, Branching, Widget } from "@/components/services/participant-service";
import { mapGetters } from "vuex";
import $ from "jquery";
import _ from "lodash";
import localStorageService from "@/services/localStorage";
import HelpMessage from "@/components/participant-portal/common/help-message";
import Modal from "@/components/participant-portal/common/modal";

export default {
  name: "activity-details",

  components: {
    BooleanPreview,
    CustomScalePreview,
    DateTimePreview,
    ImageCapturePreview,
    ImageChoicePreview,
    InstructionPreview,
    CompletionPreview,
    MultipleChoicePreview,
    NumberResponsePreview,
    NumberScalePreview,
    TextResponsePreview,
    DropDownPreview,
    MeasurementPreview,
    IndexPreview,
    LogPreview,
    WongBakerPreview,
    ValidatedEntryPreview,
    MedicationSelectorPreview,
    HelpMessage,
    Modal,
    VasPreview
  },
  data() {
    return {
      hasFieldError: true,
      widget: new Widget(),
      validations: new Validations(),
      bitrise: new Bitrise(),
      activityObj: null,
      branchingLogic: null,
      disabledFields: [],
      languageId: null,
      studyId: null,
      taskId: null,
      taskInstanceId: null,
      isLegacyStudy: false,
      isOldActivity: false,
      questionsWithImages: {},
      activity: {},
      questions: [],
      test: false,
      mode: "EDIT",
      isActivityLastQuestion: false,
      currentQuestionIndex: 0,
      currentQuestionButtonLabel: "",
      answerdQuestions: [],
      modes: {
        PREVIEW: 0,
        EDIT: 1,
        RESPONSE: 2
      },
      showPrevButton: false,
      showMessageModal: false,
      messageContent: ""
    };
  },
  props: ["adherence"],
  watch: {},
  created() {
    this.studyId = this.$route.params.studyId;
    this.taskId = this.$route.params.taskId;
    this.taskInstanceId = this.$route.params.taskInstanceId;
  },
  computed: {
    ...mapGetters(["participant", "token"]),
    adherance() {
      return this.$store.getters.getParticipantSelectedActivity;
    },
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    },
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    legacyActiveQuestions() {
      if (this.activityObj) {
        this.updateCurrentQuestionLabel();
        return this.questions[this.currentQuestionIndex];
      } else {
        return [];
      }
    },
    nonLegacyActiveQuestion() {
      if (this.activityObj) {
        this.updateCurrentQuestionLabel();
        return this.questions[this.currentQuestionIndex];
      } else {
        return [];
      }
    },
    translationKey() {
      const id = this.activity.id || this.activity.identifier || this.activity.revisionId || this.activity.activityId;
      return this.isLegacyStudy || (this.isLegacyStudy == false && this.isOldActivity) ? `${id}_name` : `${id}_taskTitle`;
    }
  },
  mounted() {
    this.taskInstanceId = this.$route.params.taskInstanceId;
    this.getTaskDetailswithImages();
    if (this.$route.params.notification !== null) {
      this.$root.$emit("notification-activity-loaded", this.$route.params.notification);
    }
  },
  methods: {
    updateCurrentQuestionLabel() {
      this.currentQuestionButtonLabel = this.activityObj.getCurrentQuestionLabel(this.currentQuestionIndex);
      this.isActivityLastQuestion = this.activityObj.isActivityLastQuestion(this.currentQuestionIndex);
    },
    onShowMessage(question) {
      this.messageContent = question;
      this.showMessageModal = question && question.addMessageEnabled;
    },
    goToPreviousQuestion() {
      if (this.currentQuestionIndex === 1) {
        this.showPrevButton = false;
      }
      this.showMessageModal = false;
      if (this.currentQuestionIndex == 0) {
        $("#activity_cancel_Modal").modal("show");
      }

      const newIndex = this.currentQuestionIndex - 1;
      this.currentQuestionIndex = newIndex >= 0 ? newIndex : 0;
      this.activityObj.setDisabledFields(this.disabledFields, true);
      if (newIndex == -1 && this.currentQuestionIndex == 0 && this.answerdQuestions.length > 0) {
        $("#activity_cancel_Modal").modal("show");
      } else {
        this.currentQuestionIndex = this.activityObj.getQuestionIndex();
        this.activityObj.setQuestionIndex(this.currentQuestionIndex);
      }
    },
    activityCancel() {
      this.$router.push({ name: "participants-portal-activity-list" });
    },
    validate(question) {
      this.showMessageModal = false;
      const result = this.validations.validate(question);

      if (typeof result !== "boolean") {
        this.hasFieldError = true;
        this.$toastr.error(result);
      } else {
        this.hasFieldError = result;
        return result;
      }
    },
    navigateToList(e) {
      this.showPrevButton = true;
      this.showMessageModal = false;
      if (this.validate(e)) {
        const activity = this.activityObj;
        const finalResponse = activity.getReponseArray(this.questions);
        this.saveResponseSurvey(finalResponse);
      }
      //this.$router.push({ name: 'participants-portal-activities', params: { 'languageId': this.languageId } });
    },
    submitEvent(e, type, skipped = false) {
      const nowDate = new Date();
      const offset = nowDate.getTimezoneOffset();
      const o = Math.abs(offset);
      const localTimeOffset = (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
      const isoDateString = nowDate.toISOString();
      this.showPrevButton = true;
      this.showMessageModal = false;
      if (this.isLegacyStudy || (this.isLegacyStudy == false && this.isOldActivity)) {
        this.answerdQuestions = this.questions.filter(q => q.isAnswered == true);
      } else {
        this.answerdQuestions = this.questions.filter(q => q.find(i => i.isAnswered == true));
      }
      e.skipped = skipped;
      this.$root.$emit('questionSkipped',e);
      e.isSkipped = skipped;
      this.branchingLogic.checkLogic(e);
      let isForward = true;
      let jumppedQuestionIndex;
      if (!skipped && this.branchingLogic.skippedRule !== undefined && this.branchingLogic.skippedRule.skipTo !== "default") {
        let skipToQuestion = {};
        this.branchingLogic.skippedRule.length ? this.branchingLogic.skippedRule.forEach(value => { skipToQuestion = value ? value.skipTo : null; }) : skipToQuestion = this.branchingLogic.skippedRule.skipTo;
        if (this.isLegacyStudy || (this.isLegacyStudy == false && this.isOldActivity)) {
          jumppedQuestionIndex = this.questions.findIndex(o => o.identifier == skipToQuestion);
          if (jumppedQuestionIndex !== -1) {
            isForward = !(jumppedQuestionIndex < this.currentQuestionIndex);
          }
        } else {
          jumppedQuestionIndex = this.questions.findIndex(o => o.map(i => i.identifier).includes(skipToQuestion));
          if (jumppedQuestionIndex !== -1) {
            isForward = !(jumppedQuestionIndex < this.currentQuestionIndex);
          }
        }
      }
      //For Recursive Branching
      else if (!skipped && !!e.skipToQuestionId) {
        const skipToId = e.skipToQuestionId;
        if (this.isLegacyStudy || (this.isLegacyStudy == false && this.isOldActivity)) {
          jumppedQuestionIndex = this.questions.findIndex(o => o.identifier == skipToId);
          if (jumppedQuestionIndex !== -1) {
            isForward = !(jumppedQuestionIndex < this.currentQuestionIndex);
          }
        } else {
          jumppedQuestionIndex = this.questions.findIndex(o => o.map(i => i.identifier).includes(skipToId));
          if (jumppedQuestionIndex !== -1) {
            isForward = !(jumppedQuestionIndex < this.currentQuestionIndex);
          }
        }
      }
      this.disabledFields = this.branchingLogic.disabledFields;
      this.activityObj.setDisabledFields(this.disabledFields, false);

      if (skipped || this.disabledFields[e.identifier] || this.validate(e)) {
        e["endTime"] = isoDateString.replace("Z", localTimeOffset);
        e["startTime"] = isoDateString.replace("Z", localTimeOffset);
        e["startTimeLocal"] = isoDateString.replace("Z", localTimeOffset);
        e["offset"] = localTimeOffset;
        e.isAnswered = true;

        if (this.answerdQuestions.length == this.questions.length) {
        } else {
          if (isForward) {
            this.currentQuestionIndex = this.activityObj.getQuestionIndex();
          } else {
            this.currentQuestionIndex = jumppedQuestionIndex == undefined ? this.activityObj.getQuestionIndex() : jumppedQuestionIndex;
          }
          if (!skipped && !!e.skipToQuestionId) {
            this.currentQuestionIndex = jumppedQuestionIndex;
          }
          this.activityObj.setQuestionIndex(this.currentQuestionIndex);
          e.skipToQuestionId = undefined;
        }
      }
    },
    saveResponseSurvey(data) {
      data.revisionId = this.activity.revisionId ? this.activity.revisionId : "";
      if (this.isLegacyStudy || (this.isLegacyStudy == false && this.isOldActivity)) {
        if (data.results.length == 0) {
          const message = this.widget.translate("pweb_error_cannot_submit_survey", "This survey cannot be submitted from here, please try from mobile.");
          if (message) {
            this.$toastr.error(message);
          }
          if (this.$route.params.notification !== null) {
            this.$root.$emit("readNotification", this.$route.params.notification);
          } else {
            this.$root.$emit("activityCompleted", this.activityObj.taskInstanceId);
          }
          return;
        }
        data.activityIsOptional = !!(this.adherance && this.adherance.activityOptional);
        this.$api
          .saveParticipantsSurveyResponse(
            {
              participantId: this.participant.pid,
              language: this.participant.languageId
            },
            data
          )
          .then(response => {
            const message = this.widget.translate(response.data.message_key, this.lang);
            if (message) {
              this.$toastr.success(message);
            } else if (response.data.message) {
              this.$toastr.success(response.data.message);
            }
            this.updateCompletedCount();
            this.updateResponseData(data);
          })
          .catch(() => {
            const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
            if (message) {
              this.$toastr.error(message);
            }
          });
      } else {
        if (data.results.length == 0) {
          const message = this.widget.translate("pweb_error_cannot_submit_survey", "This activity cannot be submitted from here, please try from mobile.");
          if (message) {
            this.$toastr.error(message);
          }
          return;
        }
        this.$api
          .saveParticipantsActivityResponse(
            {
              participantId: this.participant.pid,
              language: this.participant.languageId
            },
            data
          )
          .then(response => {
            const message = this.widget.translate(response.data.message_key, this.lang);
            if (response.data.message) {
              this.$toastr.success(this.widget.translate("SURVEY_RESPONSES_ARE_STORED", response.data.message));
            } else if (message) {
              this.$toastr.success(response.data.message);
            }
            this.updateCompletedCount();
            this.updateResponseData(data);
          })
          .catch(() => {
            const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
            if (message) {
              this.$toastr.error(message);
            }
          });
      }
    },
    updateResponseData(surveyResponse) {
      const completedTime = new Date();
      const data = {
        taskInstanceUUID: surveyResponse.taskInstanceId,
        taskId: this.taskId,
        taskType: this.$route.params.taskType,
        taskTitle: this.activity.name,
        taskClassName: "",
        taskFileName: this.taskId,
        taskStartDate: 0,
        taskEndDate: 0,
        scheduleId: this.adherance.scheduleId,
        scheduledDate: this.adherance.scheduledDate,
        completed: 1,
        completedDateTime: completedTime.getTime(),
        allowMultiple: this.adherance.allowMultiple,
        sequence: this.adherance.sequence,
        startDay: this.adherance.startDay,
        endDay: this.adherance.endDay,
        scheduleDay: this.adherance.scheduleDay,
        dailyCompletionCount: this.adherance.completedCount + 1,
        studyVersionId: surveyResponse.studyVersionId,
        activityIsOptional: surveyResponse.activityIsOptional
      };
      this.$api
        .updateParticipantComplianceAdharance(
          {
            participantId: this.participant.pid,
            studyId: this.studyId,
            deviceId: localStorageService.getItem("pw-deviceId"),
            siteId: this.study.sitesInfo[0].id,
            siteName: this.study.sitesInfo[0].name,
            deviceType: "web"
          },
          { taskSchedules: [data] }
        )
        .then(() => {
          if (this.$route.params.notification !== null) {
            this.$root.$emit("readNotification", this.$route.params.notification);
          } else {
            this.$root.$emit("activityCompleted", this.activityObj.taskInstanceId);
          }
          this.$router.push({
            name: "participants-portal-activities",
            params: { languageId: this.languageId }
          });
        })
        .catch(() => {
          const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    updateCompletedCount() {
      const data = [];
      const adherance = Object.assign({}, this.adherance);
      adherance.siteId = this.study.sitesInfo[0].id;
      adherance.siteName = this.study.sitesInfo[0].name;
      adherance.completedCount = 1;
      adherance.scheduledCount = this.adherance.scheduledCount == 0 ? 1 : this.adherance.scheduledCount;
      adherance["deviceId"] = localStorageService.getItem("pw-deviceId");
      adherance["studyVersionId"] = this.participant.myStudyVersionId;
      data.push(adherance);
      const langugageID = this.languageId || localStorageService.getItem("pw-languageId");
      this.$api
        .updateParticipantAdharance({ participantId: this.participant.pid, language: langugageID }, { results: data })
        .then(() => {})
        .catch(() => {
          const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    checkDeviceTypeActivity(response) {
      if (response.data.allowDevicesForCompletion == true) {
        if (response.data.selectedDevices.some(i => i.value == "website")) {
          return;
        } else {
          const activeDevice = response.data.selectedDevices.some(i => i.value == "tablet") && response.data.selectedDevices.some(i => i.value == "phone") ? "mobile device OR tablet" : response.data.selectedDevices.some(i => i.value == "tablet") ? "tablet" : response.data.selectedDevices.some(i => i.value == "phone") ? "mobile device" : "watch";
          let message = this.widget.translate("pweb_activity_not_configured_device", "This activity cannot be completed on the participant Web. Please sign into the study application on your {{activeDevice}} for completion.");
          message = message.replace("{{activeDevice}}", activeDevice);
          this.$toastr.error(message);
          this.$router.push({
            name: "participants-portal-activities",
            params: { languageId: this.languageId }
          });
        }
      } else {
        return;
      }
    },
    getTaskDetailswithImages() {
      this.$api
        .getPortalActivityDetailswithImageURls(this.taskId, {
          studyId: this.studyId,
          versionId: this.participant.myStudyVersionId
        })
        .then(response => {
          this.checkDeviceTypeActivity(response);
          this.questionsWithImages = response.data.questions;
          let isConstraintsPresetn = false;
          if (response.data && response.data.questions) {
            for (let x = 0; x < response.data.questions.length; x++) {
              if (Object.keys(response.data.questions[x]).includes("constraints")) {
                isConstraintsPresetn = true;
              }
            }
          }
          if (response.data.questions && isConstraintsPresetn) {
            this.activity = response.data;
            this.activityObj = new Activity(response.data, this.taskInstanceId);
            this.activityObj.languageId = localStorageService.getItem("pw-languageId");
            this.activityObj.imagesQuestions = this.questionsWithImages;
            this.isLegacyStudy = this.activityObj.isLegacyStudy();
            this.isOldActivity = this.activityObj.isOldActivity();
            this.questions = _.cloneDeep(this.activityObj.questionsArray());
            const isLegacyStudy = this.isLegacyStudy || (this.isLegacyStudy == false && this.isOldActivity);
            this.branchingLogic = new Branching(isLegacyStudy, this.questions);
            this.$store.dispatch("setSelectedActivity", this.activityObj);
          } else {
            this.regenrateTaskJson();
          }
        })
        .catch(() => {
          const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    regenrateTaskJson() {
      this.$api
        .renewParticipantTask(this.taskId, { studyId: this.studyId })
        .then(response => {
          this.activity = response.data;
          this.activityObj = new Activity(response.data, this.taskInstanceId);
          this.activityObj.languageId = localStorageService.getItem("pw-languageId");
          this.activityObj.imagesQuestions = this.questionsWithImages;
          this.isLegacyStudy = this.activityObj.isLegacyStudy();
          this.isOldActivity = this.activityObj.isOldActivity();
          this.questions = _.cloneDeep(this.activityObj.questionsArray());
          const isLegacyStudy = this.isLegacyStudy || (this.isLegacyStudy == false && this.isOldActivity);
          this.branchingLogic = new Branching(isLegacyStudy, this.questions);
          this.$store.dispatch("setSelectedActivity", this.activityObj);
        })
        .catch(() => {
          const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    onAnswerChange(step) {
      if (this.isLegacyStudy || (this.isLegacyStudy == false && this.isOldActivity)) {
        const selectedStepIndex = this.questions.findIndex(o => o.identifier == step.identifier);
        if (selectedStepIndex > -1) {
          this.questions[selectedStepIndex] = step;
        }
      } else {
        const selectedStepIndex = this.questions[this.currentQuestionIndex].findIndex(o => o.identifier == step.identifier);
        if (selectedStepIndex > -1) {
          this.questions[this.currentQuestionIndex][selectedStepIndex] = step;
        }
      }

      if (this.applyBranchingLogic) {
        this.checkForBranchingLogicOnAnswerChange(step);
      }
    }
  }
};
</script>

<style>
.card {
  box-shadow: 0 3px 4px 0px rgb(0 0 0 / 53%);
}
.inner-container {
  margin: 5% 15%;
}
.activity-details-container {
  width: 100%;
  height: calc(100vh - 130px);
  padding: 70px 0 125px;
  background-image: radial-gradient(#ffffff, rgba(255, 255, 255, 0)), linear-gradient(to bottom, #f3f3f4, #f3f3f4);
  overflow-y: auto;
}
.activity-details-container .bs-example-modal .modal-dialog {
  width: 100%;
}

.activity-details-container .bs-example-modal .modal-dialog .modal-body {
  overflow-y: auto;
}

.faqhead3 .fa-refresh {
  color: #b0bac9;
  font-size: 20px;
}
.faqhead3 .fa-check {
  color: var(--secondary);
  font-size: 24px;
}
.faqhead3 .n-times {
  color: var(--secondary);
  font-size: 11px;
}
.activity-progress-row {
  padding: 13px 0 10px 0;
}

.calender-icon {
  margin-top: -5px;
}
.progress {
  border: solid 1px var(--primary);
  background-color: #f3f3f3;
  height: 12px;
  margin-top: 5px;
  border-radius: 10px;
}
.progress-bar {
  background-color: var(--primary);
}

.activity_heading h2 {
  font-family: "lato-bold";
  font-weight: 500;
  text-align: center;
  color: #4a4a4a;
  margin-bottom: 0;
  font-size: 24px;
  letter-spacing: -0.3px;
}

.activity-modal-btn {
  cursor: pointer;
}
.activityCancelModel .modal-dialog {
  width: 400px;
}
.activityCancelModel .confirm-label {
  font-family: Roboto;
  font-size: 18px;
  font-weight: 300;
  color: #4a4a4a;
}
.modal-padding {
  padding: 25px !important;
}
.activityCancelModel .modal-dialog {
  width: 500px;
}
.custom-footer-margin {
  margin: 10% 5% 5%;
}
.select-scroll {
  height: calc(100vh - 130px);
  overflow-y: auto;
}
.instruction_info p img {
  margin: 0 auto;
  display: block;
}
.vue-box-select li input[type="radio"] {
  left: 47%;
}
.link-skip_question {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 50px;
  color: var(--secondary);
}
.link-skip_question:hover {
  text-decoration: none;
  color: var(--secondary);
}
</style>
